<template>
  <div>往届链接</div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>

</style>
